var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRaisedHandHollow = function SvgRaisedHandHollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 2.625V9.75a.75.75 0 0 0 1.5 0V3.955c0-.08.138-.205.375-.205s.375.125.375.205V9.75a.75.75 0 0 0 1.5 0V5.625a.375.375 0 0 1 .75 0v5.656C14.046 13.37 12.266 15 10.125 15a4.121 4.121 0 0 1-3.44-1.848l-.003.001-2.86-4.3c-.137-.196-.095-.43.074-.549a.375.375 0 0 1 .522.092l.96 1.434-.001.001a.75.75 0 0 0 1.371-.395h.002V4.126a.375.375 0 1 1 .75 0V9.75a.75.75 0 0 0 1.5 0V2.625a.375.375 0 1 1 .75 0Zm5.987 8.64.013-.006V5.625a1.875 1.875 0 0 0-2.259-1.836C13.4 2.925 12.6 2.25 11.625 2.25c-.14 0-.275.014-.405.04a1.876 1.876 0 0 0-3.69.004 1.875 1.875 0 0 0-2.28 1.831v2.996a1.876 1.876 0 0 0-2.675 2.566l2.701 4.041a5.625 5.625 0 0 0 10.46-2.463Z"
  })));
};

export default SvgRaisedHandHollow;